import React, {createContext, useContext, useEffect, useState} from 'react'

const TutorialContext = createContext()

export const TutorialProvider = ({ children }) => {
  const [activeTutorial, setActiveTutorial] = useState(null)
  const [floatingTutorial, setFloatingTutorial] = useState(null)

  const openTutorial = (tutorial) => setActiveTutorial(tutorial)
  const closeTutorial = () => setActiveTutorial(null)

  const openFloatingPlayer = (tutorial) => {
    setFloatingTutorial(tutorial)
    setActiveTutorial(null)
  }

  useEffect(() => {
    const on = !!(activeTutorial || floatingTutorial);
    const cls = 'bp-tutorial-open';
    document.documentElement.classList.toggle(cls, on);
  }, [activeTutorial, floatingTutorial]);

  const closeFloatingPlayer = () => setFloatingTutorial(null)

  return (
    <TutorialContext.Provider
      value={{
        activeTutorial,
        floatingTutorial,
        openTutorial,
        closeTutorial,
        openFloatingPlayer,
        closeFloatingPlayer,
      }}
    >
      {children}
    </TutorialContext.Provider>
  )
}

export const useTutorial = () => useContext(TutorialContext)
